import { render, staticRenderFns } from "./DialogSubCompany.vue?vue&type=template&id=6b2155e1&"
import script from "./DialogSubCompany.vue?vue&type=script&lang=js&"
export * from "./DialogSubCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports